import { ORGANIZATIONS_PREFIX } from "@cti-workspace/helpers";
import { postApi } from "./api";

export default async function updateOrgPDFTemplate(data) {
  const url = `/${ORGANIZATIONS_PREFIX}/updatePdfTemplates`;
  return postApi(url, data);
}
